var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dataRows,"disable-pagination":"","show-expand":"","item-key":"created_at","expanded":_vm.expanded},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('order-payment-info',{attrs:{"item":item}})],1)]}},{key:"item.paymentAmount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatWithCurrency(item.payment.amount, _vm.order.currency_code))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }